<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="6" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">
          {{ $t('customer.customers') }}
        </span>
        <h3 class="page-title">
          {{ $t('customer.addingNewCustomer') }}
        </h3>
      </d-col>
      <d-col
        col
        sm="6"
        class="text-right text-sm-right d-flex justify-content-end align-items-end">
        <d-button
          theme="secondary"
          @click.prevent="$router.push('/klienci')"
          class="mr-1">
          <i class="material-icons">arrow_back</i>
          {{ $t('ui.backToList') }}
        </d-button>

        <d-button
          theme="success"
          @click.prevent="validateForm">
          <i class="material-icons">add</i>
          {{ $t('customer.addCustomer') }}
        </d-button>
      </d-col>
    </d-row>

    <!-- Form -->
    <d-form>
      <validation-observer ref="customer-new-form" tag="form">
        <d-card class="mb-5">
          <d-tabs
            v-if="!loadError"
            v-sticky-tabs
            card
            :nav-class="allDataLoaded ? validationResults : ''">
            <!-- Dane ogólne -->
            <d-tab
              :title="$t('ui.generalInfo')"
              active>
              <h4 class="mb-3 pb-3 border-bottom">
                {{ $t('ui.generalInfo') }}
              </h4>

             <d-row>
                <d-col cols="4">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.companyName') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="name"
                        :disabled="true" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      <small class="note">
                        {{ $t('customer.nameNotice') }}
                      </small>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="2">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.dayForPayment') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="paymentDays"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="paymentDays" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="6" class="d-flex">
                  <div class="form-group w-50">
                    <label class="d-block mb-0">
                      <d-checkbox inline v-model="sendCommunication" toggle toggle-small class="mb-0">
                        {{ $t('customer.sendCommunication') }}
                      </d-checkbox>
                    </label>

                    <label class="d-block mb-0 align-middle">
                      <d-checkbox inline v-model="sendStockReport" toggle toggle-small class="mb-0 mr-1">
                        {{ $t('customer.sendReportFromStock') }}
                      </d-checkbox>
                    </label>

                    <label class="d-block mb-0">
                      <d-checkbox inline v-model="hideCustomerInQR" toggle toggle-small class="mb-0">
                        {{ $t('customer.hidecustomerInQR') }}
                      </d-checkbox>
                    </label>
                  </div>

                  <div class="form-group w-50">
                    <label class="d-block mb-0 align-middle">
                      <d-checkbox inline v-model="excludeFromInvoiceReminder" toggle toggle-small class="mb-0 mr-1">
                        {{ $t('customer.excludeFromInvoiceReminder') }}
                      </d-checkbox>
                    </label>

                    <label class="d-block mb-0 align-middle">
                      <d-checkbox inline v-model="autoSpecialRequirement" toggle toggle-small class="mb-0 mr-1">
                        {{ $t('customer.autoSpecialRequirements') }}
                      </d-checkbox>
                    </label>
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="1">
                  <div class="form-group">
                    <label>
                      {{ $t('ui.supplierAlt') }}:
                    </label>

                    <div>
                      <d-checkbox
                        inline
                        v-model="isSupplier"
                        toggle
                        toggle-small />
                    </div>
                  </div>
                </d-col>

                <d-col :cols="isSupplier ? 4 : 7">
                  <div class="form-group">
                    <label>
                      {{ $t('ui.supplierProductsReminderEmail') }}:
                    </label>

                    <validation-provider
                      rules="email"
                      name="email"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        type="email"
                        v-model="productsReminderEmail"
                        :readonly="!isSupplier" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>

                  <d-row>
                    <d-col cols="6">
                      <div class="form-group">
                        <label>
                          {{ $t('ui.sendPurchaseInvoiceEmail') }}:
                        </label>

                        <div>
                          <d-checkbox
                            inline
                            v-model="sendPurchaseInvoiceEmail"
                            toggle
                            toggle-small
                            :disabled="!isSupplier" />
                        </div>
                      </div>
                    </d-col>
                    <d-col cols="6">
                      <div class="form-group">
                        <label>
                          {{ $t('ui.purchaseInvoiceEmail') }}:
                        </label>

                        <d-input
                          type="email"
                          v-model="purchaseInvoiceEmail"
                          :readonly="!isSupplier || !sendPurchaseInvoiceEmail" />
                      </div>
                    </d-col>
                  </d-row>
                </d-col>

                <d-col
                  v-if="isSupplier"
                  cols="3">
                  <div class="form-group">
                    <label for="name">
                      {{ $t('purchase.purchaseCategory') }}:
                    </label>

                    <d-form-select
                      v-model="purchaseCategory"
                      :options="[{
                        text: $t('welcome.choose'),
                        value: null
                      }, {
                        text: $t('purchase.purchaseType.domestic'),
                        value: 'DOMESTIC'
                      }, {
                        text: $t('purchase.purchaseType.import'),
                        value: 'IMPORT'
                      }]" />
                  </div>

                  <div class="form-group">
                    <label for="name">
                      {{ $t('purchase.warehouse') }}:
                    </label>

                    <d-form-select
                      v-model="warehouse"
                      :options="[{
                        text: $t('welcome.choose'),
                        value: null
                      }, {
                        text: 'MG02',
                        value: 'MG02'
                      }, {
                        text: 'SE01',
                        value: 'SE01'
                      }, {
                        text: 'DE01',
                        value: 'DE01'
                      }]" />
                  </div>
                </d-col>

                <d-col
                  v-if="autoSpecialRequirement"
                  cols="4">
                  <div class="form-group">
                    <label>
                      {{ $t('order.isSpecialRequirement') }}:
                    </label>

                    <d-textarea
                      v-model="specialRequirement"
                      :value.prop="specialRequirement"
                      :rows="5" />
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.customerCode') }}:
                    </label>

                    <validation-provider
                      rules="required|only-letters-and-numbers|max:10"
                      name="code"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="code" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('ui.language') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="language_id"
                      v-slot="{ errors }">
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          :options="languageOptions"
                          v-model="language_id"
                          :searchable="false"
                          :clearable="false"
                          :reduce="language => language.value"
                          :placeholder="$t('settings.language.chooseLanguage')"
                          label="text">
                          <template slot="no-options">
                            {{ $t('settings.language.noLanguagesAvailable') }}&hellip;
                          </template>
                        </v-select>
                      </div>

                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('settings.currency.currency') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="currency_id"
                      v-slot="{ errors }">
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          :options="currencyOptions"
                          v-model="currency_id"
                          :searchable="false"
                          :clearable="false"
                          :reduce="currency => currency.value"
                          :placeholder="$t('settings.currency.chooseCurrency')"
                          label="text">
                          <template slot="no-options">
                            {{ $t('settings.currency.noCurrenciesAvailable') }}&hellip;
                          </template>
                        </v-select>
                      </div>

                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('ui.shipper') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="shipper_id"
                      v-slot="{ errors }">
                      <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                        <v-select
                          :options="shipperOptions"
                          v-model="shipper_id"
                          :searchable="false"
                          :clearable="false"
                          :reduce="shipper => shipper.value"
                          :placeholder="$t('shippers.chooseShipper')"
                          label="text">
                          <template slot="no-options">
                            {{ $t('shippers.noShippersAvailable') }}&hellip;
                          </template>
                        </v-select>
                      </div>

                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('settings.country.country') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="country-id"
                      v-slot="{ errors }">
                      <d-form-select
                        v-model="countryID"
                        :state="errors.length ? 'invalid' : null"
                        :options="countriesOptions"
                        @change="countryChange" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('settings.regions.region') }}:
                    </label>

                    <validation-provider
                      rules="non_zero"
                      name="region-id"
                      v-slot="{ errors }">
                      <d-form-select
                        v-model="regionID"
                        :state="errors.length ? 'invalid' : null"
                        :options="regionsOptions" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.sourceOfGain') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="source-id"
                      v-slot="{ errors }">
                      <d-form-select
                        v-model="sourceID"
                        :state="errors.length ? 'invalid' : null"
                        :options="sourcesOptions" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col
                  v-if="userIsAdmin"
                  cols="3">
                  <div class="form-group">
                    <label>
                      {{ $t('agents.selectAgent') }}:
                    </label>

                    <select-agent />
                  </div>
                </d-col>
              </d-row>

              <div class="form-group">
                <label>
                  {{ $t('customer.customerLogo') }}:
                </label>

                <file-input
                  :onChange="setCustomerLogo"
                  id="inputFileCustomerLogo" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('ui.emailAddress') }}:
                </label>

                <validation-provider
                  rules="required|email"
                  name="email"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    type="email"
                    v-model="email" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('customer.telephone') }}:
                </label>

                <d-input
                  v-mask="'+## ### ### ### ### ### ### ### ### ###'"
                  v-model="phone" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('customer.termsOfSale') }}:
                </label>

                <d-textarea
                  v-model="termsOfSale"
                  :value.prop="termsOfSale" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('customer.termsOfSaleIndent') }}:
                </label>

                <d-textarea
                  v-model="termsOfSaleIndent"
                  :value.prop="termsOfSaleIndent" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.customerTags.customerTags') }}:
                </label>

                <ul class="customer-tags-list">
                  <li
                    v-for="(tag, index) of customerTags"
                    :key="'customer-tag-' + index">
                    <d-checkbox
                      inline
                      v-model="tags[tag.id]">
                      <d-badge :style="'background-color:' + tag.color + '; color: ' + contrastColor(tag.color) + ';'">
                        {{ tag.name }}
                      </d-badge>
                    </d-checkbox>
                  </li>
                </ul>
              </div>
            </d-tab>

            <d-tab :title="$t('customer.correspondenceInfo')">
              <div
                v-if="invoiceDataNotFromGUS"
                class="form-group d-flex">
                <d-button
                  theme="success"
                  :outline="true"
                  class="ml-auto mr-auto"
                  @click.prevent="setInvoiceDataAsCorrespondenceData">
                  {{ $t('customer.setInvoiceDataAsCorrespondenceData') }}
                </d-button>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('settings.country.country') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="correspondence-country-id"
                  v-slot="{ errors }">
                  <d-form-select
                    v-model="correspondenceCountryID"
                    :state="errors.length ? 'invalid' : null"
                    :options="countriesOptions" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('ui.nameAndSurename') }}:
                </label>

                <d-input
                  v-model="correspondenceName" />
              </div>

              <div class="form-group">
                <label>
                  {{ $t('ui.companyName') }}:
                </label>

                <validation-provider
                  rules="required"
                  name="correspondence-company-name"
                  v-slot="{ errors }">
                  <d-input
                    :state="errors.length ? 'invalid' : null"
                    v-model="correspondenceCompanyName" />
                  <div class="invalid-feedback">
                    {{ errors[0] }}
                  </div>
                </validation-provider>
              </div>

              <d-row>
                <d-col cols="12" md="10" lg="10">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.city') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="correspondence-city"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="correspondenceCity" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="12" md="2" lg="2">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.zipCode') }}:
                    </label>

                    <validation-provider
                      :rules="polandCountryID === correspondenceCountryID ? 'required|postal_code_pl' : 'required'"
                      name="correspondence-postcode"
                      v-slot="{ errors }">
                      <d-input
                        v-if="polandCountryID === correspondenceCountryID"
                        key="correspondence-postcode-mask"
                        v-mask="'##-###'"
                        :state="errors.length ? 'invalid' : null"
                        v-model="correspondencePostcode" />
                      <d-input
                        v-else
                        key="correspondence-postcode-nomask"
                        :state="errors.length ? 'invalid' : null"
                        v-model="correspondencePostcode" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="12" md="8" lg="8">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.street') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="correspondence-street"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="correspondenceStreet" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="12" md="2" lg="2">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.buildingNumber') }}:
                    </label>

                    <d-input v-model="correspondenceBuilding" />
                  </div>
                </d-col>

                <d-col cols="12" md="2" lg="2">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.houseNumber') }}:
                    </label>

                    <d-input v-model="correspondenceLocale" />
                  </div>
                </d-col>
              </d-row>
            </d-tab>

            <d-tab :title="$t('customer.shippingInfo')">
              <p class="text-center">{{ $t('customer.addingShippingAddressAvailableAfterCustomerSave') }}</p>
            </d-tab>

            <d-tab :title="$t('customer.invoiceInfo')">
              <d-row>
                <d-col cols="12" md="2" lg="2">
                  <div class="form-group">
                    <label>
                      {{ $t('settings.country.countryCode') }}:
                    </label>

                    <validation-provider
                      :rules="nonVerifiedCountryIDs.indexOf(countryID) > -1 ? '' : 'required'"
                      name="invoice-country-prefix"
                      v-slot="{ errors }">
                      <d-form-select
                        v-model="invoiceCountryPrefix"
                        :state="errors.length ? 'invalid' : null"
                        :options="countriesCodesOptions" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="12" md="8" lg="8">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.vatIDNumber') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="invoice-tax-number"
                      v-mask="'XXXXXXXXXXXXXXX'"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="invoiceTaxNumber" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="12" md="2" lg="2" class="pt-4">
                  <d-button
                    v-if="invoiceCountryPrefix && nonVerifiedCountryPrefixes.indexOf(invoiceCountryPrefix) === -1"
                    theme="success"
                    :disabled="checkingTaxNumber"
                    class="mt-2"
                    @click.prevent="verifyCustomerTaxID">
                    <div
                      v-if="checkingTaxNumber"
                      class="spinner-border spinner-border-sm"
                      role="status"></div>
                    <template v-if="invoiceCountryPrefix === 'PL'">{{ $t('customer.getDataFromGUS') }}</template>
                    <template v-else>{{ $t('customer.getDataFromVIES') }}</template>
                  </d-button>

                  <template v-if="invoiceCountryPrefix && nonVerifiedCountryPrefixes.indexOf(invoiceCountryPrefix) === -1">
                    <small
                      v-if="invoiceCountryPrefix === 'PL' && !gusEnabled"
                      class="text-danger d-block">
                      {{ $t('settings.integrations.integrationIsDisabled') }}
                    </small>

                    <small
                      v-if="invoiceCountryPrefix !== 'PL' && !viesEnabled"
                      class="text-danger d-block">
                      {{ $t('settings.integrations.integrationIsDisabled') }}
                    </small>
                  </template>
                </d-col>
              </d-row>

              <d-row v-if="!!taxNumberVerifiedAt">
                <d-col cols="12" class="pb-3">
                  <small>
                    {{ $t('customer.lastTaxVerification') }}
                    <span class="text-primary">
                      {{ taxNumberVerifiedAt }}
                    </span> |
                    {{ $t('customer.retrievedStatus') }}
                    <span
                      v-if="taxNumberVerifiedStatus === 'VALID'"
                      class="text-success">
                      {{ $t('customer.validTaxNumber') }}
                    </span>
                    <span
                      v-if="taxNumberVerifiedStatus === 'INVALID'"
                      class="text-danger">
                      {{ $t('customer.invalidTaxNumber') }}
                    </span>

                    <span class="px-2"> | </span>
                    {{ $t('customer.vatIDActiveDuringCheck') }}:
                    <d-badge
                      v-if="taxNumberVerifiedIsActive"
                      theme="success">
                      {{ $t('ui.yes') }}
                    </d-badge>
                    <d-badge
                      v-if="!taxNumberVerifiedIsActive"
                      theme="danger">
                      {{ $t('ui.no') }}
                    </d-badge>
                  </small>
                </d-col>
              </d-row>

              <d-row>
                <d-col :cols="invoiceReceiver !== 'CUSTOM_EMAIL' ? 12 : 6">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.invoiceReceiver') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="invoice-receiver"
                      v-slot="{ errors }">
                      <d-form-select
                        v-model="invoiceReceiver"
                        :state="errors.length ? 'invalid' : null"
                        :options="[{
                          'text': $t('welcome.choose'),
                          'value': null
                        }, {
                          'text': $t('users.customer'),
                          'value': 'CUSTOMER'
                        }, {
                          'text': $t('customer.contactInsideOrder'),
                          'value': 'ORDER_CONTACT'
                        }, {
                          'text': $t('ui.emailAddress'),
                          'value': 'CUSTOM_EMAIL'
                        }]">
                      </d-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col
                  v-if="invoiceReceiver === 'CUSTOM_EMAIL'"
                  cols="6">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.invoiceReceiverEmailAddress') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="invoice-email"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="invoiceEmail" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="12">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.invoiceName') }}
                    </label>

                    <validation-provider
                      rules="required"
                      name="invoice-name"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="invoiceName"
                        @input="name = invoiceName" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="12" md="10" lg="10">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.city') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="invoice-city"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="invoiceCity" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="12" md="2" lg="2">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.zipCode') }}:
                    </label>

                    <validation-provider
                      :rules="invoiceCountryPrefix === 'PL' ? 'required|postal_code_pl' : 'required'"
                      name="invoice-postcode"
                      v-slot="{ errors }">
                      <d-input
                        v-if="invoiceCountryPrefix === 'PL'"
                        key="invoice-postcode-mask"
                        v-mask="'##-###'"
                        :state="errors.length ? 'invalid' : null"
                        v-model="invoicePostcode" />
                      <d-input
                        v-else
                        key="invoice-postcode-nomask"
                        :state="errors.length ? 'invalid' : null"
                        v-model="invoicePostcode" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>
              </d-row>

              <d-row>
                <d-col cols="12" md="8" lg="8">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.street') }}:
                    </label>

                    <validation-provider
                      rules="required"
                      name="invoice-street"
                      v-slot="{ errors }">
                      <d-input
                        :state="errors.length ? 'invalid' : null"
                        v-model="invoiceStreet" />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </validation-provider>
                  </div>
                </d-col>

                <d-col cols="12" md="2" lg="2">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.buildingNumber') }}:
                    </label>

                    <d-input v-model="invoiceBuilding" />
                  </div>
                </d-col>

                <d-col cols="12" md="2" lg="2">
                  <div class="form-group">
                    <label>
                      {{ $t('customer.houseNumber') }}:
                    </label>

                    <d-input v-model="invoiceLocale" />
                  </div>
                </d-col>
              </d-row>
            </d-tab>

            <d-tab :title="$t('customer.discount.discounts')">
              <div class="form-group">
                <label>
                  {{ $t('customer.discount.serviceDiscount') }}:
                </label>

                <validation-provider
                  rules="required|min_value:0|max_value:100"
                  name="discount-services"
                  v-slot="{ errors }">
                  <d-input-group
                    prepend="%"
                    :class="{'mb-2': true, 'is-invalid': errors.length}">
                    <input
                      :class="{
                        'form-control': true,
                        'is-invalid': errors.length
                      }"
                      :invalid="errors.length ? true : null"
                      type="number"
                      v-model="discountServices" />
                    <d-input-group-text slot="append">%</d-input-group-text>
                  </d-input-group>
                  <d-form-invalid-feedback>
                    {{ errors[0] }}
                  </d-form-invalid-feedback>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('customer.discount.shippingDiscount') }}:
                </label>

                <validation-provider
                  rules="required|min_value:0|max_value:100"
                  name="discount-shipping"
                  v-slot="{ errors }">
                  <d-input-group
                    prepend="%"
                    :class="{'mb-2': true, 'is-invalid': errors.length}">
                    <input
                      :class="{
                        'form-control': true,
                        'is-invalid': errors.length
                      }"
                      :invalid="errors.length ? true : null"
                      type="number"
                      v-model="discountShipping" />
                    <d-input-group-text slot="append">%</d-input-group-text>
                  </d-input-group>
                  <d-form-invalid-feedback>
                    {{ errors[0] }}
                  </d-form-invalid-feedback>
                </validation-provider>
              </div>

              <div class="form-group">
                <label>
                  {{ $t('customer.discount.productDiscount') }}:
                </label>

                <validation-provider
                  rules="required|min_value:0|max_value:100"
                  name="discount-products"
                  v-slot="{ errors }">
                  <d-input-group
                    prepend="%"
                    :class="{'mb-2': true, 'is-invalid': errors.length}">
                    <input
                      :class="{
                        'form-control': true,
                        'is-invalid': errors.length
                      }"
                      :invalid="errors.length ? true : null"
                      type="number"
                      v-model="discountProducts" />
                    <d-input-group-text slot="append">%</d-input-group-text>
                  </d-input-group>
                  <d-form-invalid-feedback>
                    {{ errors[0] }}
                  </d-form-invalid-feedback>
                </validation-provider>
              </div>

              <div class="form-group">
                <d-checkbox
                  inline
                  v-model="indentDiscountEnabled"
                  toggle
                  toggle-small
                  class="mb-0">
                  {{ $t('customer.indentDiscountEnabled') }}
                </d-checkbox>
              </div>
            </d-tab>

            <d-tab :title="$t('customer.contactPeople')">
              <p class="text-center">
                {{ $t('customer.addingContactPersonAvailableAfterCustomerSave') }}
              </p>
            </d-tab>

            <d-tab :title="$t('settings.transaltion.translations')">
              <p class="text-center">
                {{ $t('customer.addingTransaltionsAvailableAfterCustomerSave') }}
              </p>
            </d-tab>

            <d-tab :title="$t('customer.contactsWithCustomer')">
              <p class="text-center">
                {{ $t('customer.customerContactsInforAvailableAfterCustomerSave') }}&hellip;
              </p>
            </d-tab>

            <d-tab :title="$t('price.pricesLists')">
              <d-alert
                show
                theme="warning">
                {{ $t('customer.addingPricesWillBeAvailableAfterContractorSave') }}
              </d-alert>
            </d-tab>

            <d-tab :title="$t('customer.history')">
              <d-alert
                show
                theme="warning">
                {{ $t('customer.historyWillBeAvailableAfterCustomerSave') }}
              </d-alert>
            </d-tab>
          </d-tabs>

          <div v-if="!allDataLoaded" class="pb-3 pt-3 text-center overlay-loading">
            {{ $t('ui.dataLoading') }}&hellip;
          </div>

          <d-alert
            v-if="loadError"
            show
            theme="warning">
            {{ $t('ui.dataLoadingFailed') }} <a href="javascript:window.location.reload();" class="alert-link">{{ $t('ui.refreshPage') }}</a> {{ $t('ui.toTryAgain') }}
          </d-alert>
        </d-card>
      </validation-observer>
    </d-form>
  </d-container>
</template>

<script>
import CommonGetters from './../../utils/CommonGetters.js';
import FormUtils from './../../utils/FormUtils.js';
import SelectAgent from './../common/SelectAgent.vue';
import Vue from 'vue';

export default {
  name: 'customer-new',
  components: {
    'select-agent': SelectAgent
  },
  computed: {
    allDataLoaded () {
      return this.loadedSources && this.loadedCountries && this.loadedLanguages && this.loadedCurrencies && this.loadedShippers && this.loadedCustomerTags && this.loadedIntegrations && this.loadedRegions;
    },
    countriesOptions () {
      return [{ value: '', text: this.$t('settings.country.selectCountry') }].concat(CommonGetters.getCountriesForSelect(this.countries));
    },
    countriesCodesOptions () {
      return [{ value: '', text: this.$t('settings.country.selectCountry') }].concat(CommonGetters.getCountriesCodesForSelect(this.countries));
    },
    regionsOptions () {
      return [{ value: 0, text: this.$t('settings.regions.selectRegion') }].concat(this.regions.map(region => ({
        value: region.id,
        text: region.name
      })));
    },
    fromPotentialCustomer () {
      if (this.$route.params.potentialid && parseInt(this.$route.params.potentialid, 10)) {
        return true;
      }

      return false;
    },
    fromMarketCustomer () {
      if (this.$route.params.marketid && parseInt(this.$route.params.marketid, 10)) {
        return true;
      }

      return false;
    },
    sourcesOptions () {
      return CommonGetters.getSourcesForSelect(this.sources);
    },
    validationResults () {
      let errors = this.$refs['customer-new-form'].errors;
      let errorTabs = [];
      let results = [
        ['error-1', ['name', 'source-id', 'region-id', 'phone', 'email', 'code', 'shipper_id', 'paymentDays', 'country-id']],
        ['error-2', ['correspondence-country-id', 'correspondence-name', 'correspondence-city', 'correspondence-postcode', 'correspondence-street']],
        ['error-4', ['invoice-name', 'invoice-country-prefix', 'invoice-receiver', 'invoice-email', 'invoice-tax-number', 'invoice-city', 'invoice-postcode', 'invoice-street']],
        ['error-5', ['discount-services', 'discount-shipping', 'discount-products']]
      ];

      for (let i = 0; i < results.length; i++) {
        for (let j = 0; j < results[i][1].length; j++) {
          let key = results[i][1][j];

          if (errors[key] && errors[key].length) {
            errorTabs.push(results[i][0]);
            break;
          }
        }
      }

      return errorTabs.join(' ');
    },
    languageOptions () {
      return this.languages.map(language => ({
        value: language.id,
        text: language.code
      }));
    },
    currencyOptions () {
      return this.currencies.map(currency => ({
        value: currency.id,
        text: currency.code
      }));
    },
    shipperOptions () {
      return this.shippers.map(shipper => ({
        value: shipper.id,
        text: shipper.name
      }));
    },
    polandCountryID () {
      let countryPL = this.countries.filter(country => country.code === 'PL');

      if (countryPL[0]) {
        return countryPL[0].id;
      }

      return false;
    },
    nonVerifiedCountryIDs () {
      return this.countries.filter(country => country.verify_tax_number === 0).map(country => country.id);
    },
    nonVerifiedCountryPrefixes () {
      return this.countries.filter(country => country.verify_tax_number === 0).map(country => country.code);
    },
    gusEnabled () {
      if (this.integrations.length) {
        let gusItem = this.integrations.filter(integration => integration.type === 'GUS_REGON');

        if (gusItem[0]) {
          return gusItem[0].enabled === 1;
        }
      }

      return false;
    },
    viesEnabled () {
      if (this.integrations.length) {
        let viesItem = this.integrations.filter(integration => integration.type === 'VIES');

        if (viesItem[0]) {
          return viesItem[0].enabled === 1;
        }
      }

      return false;
    },
    necessaryIntegrationEnabled () {
      if (this.countryID === this.polandCountryID) {
        return this.gusEnabled;
      }

      return this.viesEnabled;
    },
    invoiceDataNotFromGUS () {
      return this.invoiceCountryPrefix && this.invoiceCountryPrefix !== 'PL';
    },
    userIsAdmin () {
      return this.$store.getters.getUserType === 'admin';
    }
  },
  watch: {
    allDataLoaded (newValue) {
      if (newValue) {
        if (this.sources.length) {
          this.sourceID = this.sources[0].id;
        }
      }
    }
  },
  data() {
    return {
      name: '',
      code: '',
      email: '',
      phone: '',
      termsOfSale: '',
      termsOfSaleIndent: '',
      sourceID: 0,
      countryID: '',
      regionID: 0,
      agentID: null,
      logo: '',
      tags: {},
      paymentDays: '0',
      isSupplier: false,
      sendCommunication: true,
      excludeFromInvoiceReminder: false,
      hideCustomerInQR: false,
      sendStockReport: false,
      currency_id: null,
      language_id: null,
      shipper_id: null,
      correspondenceCountryID: '',
      correspondenceName: '',
      correspondenceCompanyName: '',
      correspondenceStreet: '',
      correspondenceBuilding: '',
      correspondenceLocale: '',
      correspondencePostcode: '',
      correspondenceCity: '',
      invoiceReceiver: null,
      invoiceName: '',
      invoiceEmail: '',
      invoiceStreet: '',
      invoiceBuilding: '',
      invoiceLocale: '',
      invoicePostcode: '',
      invoiceCity: '',
      invoiceTaxNumber: '',
      invoiceCountryPrefix: '',
      discountServices: 0,
      discountProducts: 0,
      discountShipping: 0,
      autoSpecialRequirement: false,
      specialRequirement: '',
      indentDiscountEnabled: false,
      productsReminderEmail: '',
      sendPurchaseInvoiceEmail: false,
      purchaseInvoiceEmail: '',
      purchaseCategory: null,
      taxNumberVerifiedAt: null,
      taxNumberVerifiedStatus: null,
      taxNumberVerifiedIsActive: false,
      loadedSources: false,
      loadedCountries: false,
      loadedCustomerTags: false,
      loadedIntegrations: false,
      loadedLanguages: false,
      loadedCurrencies: false,
      loadedShippers: false,
      loadedRegions: false,
      countries: [],
      currencies: [],
      customerTags: [],
      integrations: [],
      sources: [],
      languages: [],
      shippers: [],
      regions: [],
      loadError: false,
      checkingTaxNumber: false,
      warehouse: null,
      // helpers
      lastCheckedPrefix: null,
      lastCheckedInvoiceTaxNumber: null,
      taxNumberVerificationID: null
    };
  },
  mounted () {
    this.loadAdditionalData();

    if (this.fromPotentialCustomer) {
      this.loadAndSetPotentialCustomerData();
    }

    if (this.fromMarketCustomer) {
      this.loadAndSetMarketCustomerData();
    }

    this.$bus.$on('ui-select-agent-updated', this.setAgentID);
  },
  methods: {
    setCustomerLogo (event) {
      this.logo = event.target.files[0];
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/countries/items',
        loadedKey: 'loadedCountries',
        outputKey: 'countries',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/sources/items',
        loadedKey: 'loadedSources',
        outputKey: 'sources',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/shippers/items',
        loadedKey: 'loadedShippers',
        outputKey: 'shippers',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/languages/items',
        loadedKey: 'loadedLanguages',
        outputKey: 'languages',
        errorKey: 'loadError',
        successAction: () => {
          this.languages.reverse();
        }
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/currencies/items',
        loadedKey: 'loadedCurrencies',
        outputKey: 'currencies',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/customers/regions/items',
        loadedKey: 'loadedRegions',
        outputKey: 'regions',
        errorKey: 'loadError'
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/customers/tags/items',
        loadedKey: 'loadedCustomerTags',
        outputKey: 'customerTags',
        errorKey: 'loadError',
        params: {
          return: 'get'
        },
        successAction: () => {
          if (this.customerTags.length) {
            for (let i = 0; i < this.customerTags.length; i++) {
              let tag = this.customerTags[i];

              if (tag.default_checked) {
                this.tags[tag.id] = true;
              }
            }
          }
        }
      });

      FormUtils.loadAdditionalData(this, {
        endpoint: '/integrations/items',
        loadedKey: 'loadedIntegrations',
        outputKey: 'integrations',
        errorKey: 'loadError'
      });
    },
    loadAndSetPotentialCustomerData () {
      let potentialCustomerID = parseInt(this.$route.params.potentialid, 10);

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/potential-customers/item/' + potentialCustomerID,
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('potentialCustomers.errorLoadingData'),
        successAction: (response) => {
          this.name = response.data.name;
          this.email = response.data.email;
          this.phone = response.data.phone;
          this.invoiceTaxNumber = response.data.tax_number;

          Vue.swal({
            title: this.$t('potentialCustomers.dataLoadedCorrectlyTitle'),
            html: this.$t('potentialCustomers.dataLoadedCorrectlyDesc'),
            type: 'success',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });
        }
      });
    },
    loadAndSetMarketCustomerData () {
      let marketCustomerID = parseInt(this.$route.params.marketid, 10);

      FormUtils.submitInBackground({
        $http: this.$http,
        endpoint: '/market-customers/item/' + marketCustomerID,
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('marketCustomers.errorLoadingData'),
        successAction: (response) => {
          if (response.data.customer_exists) {
            Vue.swal({
              title: this.$t('marketCustomers.customerExistsTitle'),
              html: this.$t('marketCustomers.customerExistsDesc'),
              type: 'success',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });
            return;
          }

          this.name = response.data.name;
          this.email = response.data.email;
          this.phone = response.data.phone;
          // invoice data
          this.invoiceName = response.data.name;
          this.invoicePostcode = response.data.invoice_postcode;
          this.invoiceCity = response.data.invoice_city;
          this.invoiceStreet = response.data.invoice_street;
          this.invoiceBuilding = response.data.invoice_building;
          this.invoiceLocale = response.data.invoice_locale;
          this.invoiceCountryPrefix = response.data.invoice_country_prefix;
          this.invoiceTaxNumber = response.data.invoice_tax_number;
          // contact data
          this.correspondenceCompanyName = response.data.name;
          this.correspondenceStreet = response.data.invoice_street;
          this.correspondenceBuilding = response.data.invoice_building;
          this.correspondenceLocale = response.data.invoice_locale;
          this.correspondencePostcode = response.data.invoice_postcode;
          this.correspondenceCity = response.data.invoice_city;

          // language and currency
          Vue.set(this, 'language_id', response.data.language_id);
          Vue.set(this, 'currency_id', response.data.currency_id);

          Vue.swal({
            title: this.$t('marketCustomers.dataLoadedCorrectlyTitle'),
            html: this.$t('marketCustomers.dataLoadedCorrectlyDesc'),
            type: 'success',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });
        }
      });
    },
    validateForm () {
      if (!this.taxNumberVerificationID) {
        if (
          this.necessaryIntegrationEnabled &&
          this.nonVerifiedCountryIDs.indexOf(this.countryID) === -1 && (
            this.taxNumberVerificationID === null ||
            this.lastCheckedPrefix === null ||
            this.lastCheckedInvoiceTaxNumber === null
          )
        ) {
          Vue.swal({
            title: this.$t('customer.youMustCheckTaxID'),
            html: this.$t('customer.youMustCheckTaxIDDesc'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          return;
        }

        if (
          this.necessaryIntegrationEnabled &&
          this.nonVerifiedCountryIDs.indexOf(this.countryID) === -1 && (
            this.invoiceCountryPrefix !== this.lastCheckedPrefix ||
            this.invoiceTaxNumber !== this.lastCheckedInvoiceTaxNumber
          )
        ) {
          Vue.swal({
            title: this.$t('customer.youMustCheckTaxID'),
            html: this.$t('customer.youMustCheckCurrentTaxIDDesc'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          return;
        }
      }

      FormUtils.validate(this.$refs['customer-new-form'], this.submitForm);
    },
    submitForm () {
      if (!this.taxNumberVerificationID) {
        if (
          this.necessaryIntegrationEnabled &&
          this.nonVerifiedCountryIDs.indexOf(this.countryID) === -1 &&
          !this.taxNumberVerifiedAt
        ) {
          Vue.swal({
            title: this.$t('customer.youMustProvideTaxNumberTitle'),
            html: this.$t('customer.youMustProvideTaxNumberDesc'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          return;
        }

        if (
          this.necessaryIntegrationEnabled &&
          this.nonVerifiedCountryIDs.indexOf(this.countryID) === -1 && (
            this.taxNumberVerifiedStatus === 'INVALID' ||
            !this.taxNumberVerifiedIsActive
          )
        ) {
          Vue.swal({
            title: this.$t('customer.youMustProvideValidTaxNumberTitle'),
            html: this.$t('customer.youMustProvideValidTaxNumberDesc'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          return;
        }
      }

      let imageFields = false;
      let potentialCustomerID = parseInt(this.$route.params.potentialid, 10);
      let marketCustomerID = parseInt(this.$route.params.marketid, 10);
      let formDataToSend = {
        name: this.name,
        code: this.code,
        email: this.email,
        phone: this.phone,
        terms_of_sale: this.termsOfSale,
        terms_of_sale_indent: this.termsOfSaleIndent,
        source_id: this.sourceID,
        country_id: this.countryID,
        region_id: this.regionID,
        payment_days: this.paymentDays,
        is_supplier: +this.isSupplier,
        products_reminder_email: this.productsReminderEmail,
        send_purchase_invoice_email: this.sendPurchaseInvoiceEmail,
        purchase_invoice_email: this.purchaseInvoiceEmail,
        exclude_from_invoice_reminder: +this.excludeFromInvoiceReminder,
        send_communication: +this.sendCommunication,
        send_stock_report: +this.sendStockReport,
        hide_customer_in_qr: +this.hideCustomerInQR,
        currency_id: this.currency_id,
        language_id: this.language_id,
        shipper_id: this.shipper_id,
        correspondence_country_id: this.correspondenceCountryID,
        correspondence_name: this.correspondenceName,
        correspondence_company_name: this.correspondenceCompanyName,
        correspondence_street: this.correspondenceStreet,
        correspondence_building: this.correspondenceBuilding,
        correspondence_locale: this.correspondenceLocale,
        correspondence_postcode: this.correspondencePostcode,
        correspondence_city: this.correspondenceCity,
        invoice_receiver: this.invoiceReceiver,
        invoice_name: this.invoiceName,
        invoice_email: this.invoiceEmail,
        invoice_street: this.invoiceStreet,
        invoice_building: this.invoiceBuilding,
        invoice_locale: this.invoiceLocale,
        invoice_postcode: this.invoicePostcode,
        invoice_city: this.invoiceCity,
        invoice_tax_number: this.invoiceTaxNumber,
        invoice_country_prefix: this.invoiceCountryPrefix,
        discount_services: this.discountServices,
        discount_products: this.discountProducts,
        discount_shipping: this.discountShipping,
        indent_discount_enabled: this.indentDiscountEnabled,
        auto_special_requirement: this.autoSpecialRequirement,
        special_requirement: this.autoSpecialRequirement ? this.specialRequirement : '',
        tags: this.prepareTags()
      };

      if (this.taxNumberVerificationID) {
        formDataToSend.tax_number_verification_id = this.taxNumberVerificationID;
      }

      if (this.userIsAdmin) {
        formDataToSend.agent_id = this.agentID;
      }

      if (this.isSupplier && this.purchaseCategory) {
        formDataToSend.purchase_category = this.purchaseCategory;
      }

      if (this.isSupplier && this.warehouse) {
        formDataToSend.warehouse = this.warehouse;
      }

      if (this.logo) {
        formDataToSend.logo = this.logo;
        imageFields = ['logo'];
      }

      if (potentialCustomerID) {
        formDataToSend.potential_customer_id = potentialCustomerID;
      }

      if (marketCustomerID) {
        formDataToSend.market_customer_id = marketCustomerID;
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint: '/customers/store',
        formData: formDataToSend,
        successTitle: this.$t('customer.addCustomerSuccessTitle'),
        successText: this.$t('customer.addCustomerSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.addCustomerErrorText'),
        successAction: () => {
          this.$router.push('/klienci')
        }
      }, imageFields);
    },
    contrastColor (colorBg) {
      let threshold = 130;
      let r = parseInt(colorBg.replace('#', '').substring(0, 2), 16);
      let g = parseInt(colorBg.replace('#', '').substring(2, 4), 16);
      let b = parseInt(colorBg.replace('#', '').substring(4, 6), 16);
      let brightness = ((r * 299) + (g * 587) + (b * 114)) / 1000;

      if (brightness > threshold) {
        return '#000';
      }

      return '#fff';
    },
    prepareTags () {
      let output = [];
      let tagIDs = Object.keys(this.tags);

      for (let i = 0; i < tagIDs.length; i++) {
        if (this.tags[tagIDs[i]]) {
          output.push(tagIDs[i]);
        }
      }

      return output;
    },
    verifyCustomerTaxID () {
      if (!this.invoiceCountryPrefix) {
        Vue.swal({
          title: this.$t('customer.youMustSelectCountryPrefix'),
          html: this.$t('customer.youMustSelectCountryPrefixDesc'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });

        return;
      }

      this.checkingTaxNumber = true;
      this.taxNumberVerificationID = null;

      this.$http.get('/customers/verify-tax-number', {
        params: {
          id: 0,
          prefix: this.invoiceCountryPrefix,
          number: this.invoiceTaxNumber
        }
      }).then(response => {
        this.checkingTaxNumber = false;

        if (response.data.verification && response.data.verification.is_exception) {
          Vue.swal({
            title: this.$t('ui.errorOccured'),
            html: this.$t('customer.viesCommunicationIssue'),
            type: 'error',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });

          this.taxNumberVerificationID = response.data.verification.id;
        } else if (response.data.success) {
          if (response.data.verification && response.data.verification.status === 'VALID') {
            if (this.invoiceCountryPrefix === 'PL') {
              let previousInvoiceData = [
                this.invoiceCity,
                this.invoiceName,
                this.invoicePostcode,
                this.invoiceStreet,
                this.invoiceBuilding,
                this.invoiceLocale
              ].join('|');

              this.invoiceCity = response.data.verification.response.city;
              this.invoiceName = response.data.verification.response.name;
              this.invoicePostcode = response.data.verification.response.postCode;

              if (this.invoicePostcode && this.invoiceCountryPrefix === 'PL') {
                this.invoicePostcode = this.invoicePostcode;
              }

              this.invoiceStreet = response.data.verification.response.street;

              if (this.invoiceStreet && this.invoiceStreet.substr(0, 4) === 'ul. ') {
                this.invoiceStreet = this.invoiceStreet.replace('ul. ', '');
              }

              this.invoiceBuilding = response.data.verification.response.streetNumber;
              this.invoiceLocale = response.data.verification.response.houseNumber;

              let newInvoiceData = [
                this.invoiceCity,
                this.invoiceName,
                this.invoicePostcode,
                this.invoiceStreet,
                this.invoiceBuilding,
                this.invoiceLocale
              ].join('|');

              let previousCorrespondenceData = [
                this.correspondenceCountryID,
                this.correspondenceCity,
                this.correspondenceCompanyName,
                this.correspondencePostcode,
                this.correspondenceStreet,
                this.correspondenceBuilding,
                this.correspondenceLocale
              ].join('|');

              let newCorrespondenceData = [
                parseInt(this.polandCountryID, 10),
                this.invoiceCity,
                this.invoiceName,
                this.invoicePostcode,
                this.invoiceStreet,
                this.invoiceBuilding,
                this.invoiceLocale
              ].join('|');

              if (previousCorrespondenceData !== newCorrespondenceData) {
                this.correspondenceCountryID = parseInt(this.polandCountryID, 10);
                this.correspondenceCity = this.invoiceCity;
                this.correspondenceCompanyName = this.invoiceName;
                this.correspondencePostcode = this.invoicePostcode;
                this.correspondenceStreet = this.invoiceStreet;
                this.correspondenceBuilding = this.invoiceBuilding;
                this.correspondenceLocale = this.invoiceLocale;
              }

              if (previousCorrespondenceData !== newCorrespondenceData && previousInvoiceData !== newInvoiceData) {
                Vue.swal({
                  title: this.$t('customer.invoiceAndCorrespondenceAddressSet'),
                  html: this.$t('customer.invoiceAndCorrespondenceAddressSetDesc'),
                  type: 'info',
                  confirmButtonText: this.$t('ui.ok'),
                  buttonsStyling: true
                });
              } else if (previousCorrespondenceData !== newCorrespondenceData) {
                Vue.swal({
                  title: this.$t('customer.correspondenceAddressSet'),
                  html: this.$t('customer.correspondenceAddressSetDesc'),
                  type: 'info',
                  confirmButtonText: this.$t('ui.ok'),
                  buttonsStyling: true
                });
              } else if (previousInvoiceData !== newInvoiceData) {
                Vue.swal({
                  title: this.$t('customer.invoiceAddressSet'),
                  html: this.$t('customer.invoiceAddressSetDesc'),
                  type: 'info',
                  confirmButtonText: this.$t('ui.ok'),
                  buttonsStyling: true
                });
              }
            }

            this.taxNumberVerificationID = response.data.verification.id;
            this.lastCheckedPrefix = this.invoiceCountryPrefix;
            this.lastCheckedInvoiceTaxNumber = this.invoiceTaxNumber;
          } else if (response.data.integration_disabled === 1) {
            Vue.swal({
              title: this.$t('customer.verificationIntegrationDisabledTitle'),
              html: this.$t('customer.verificationIntegrationDisabledDesc'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });

            this.taxNumberVerificationID = response.data.verification.id;
          } else if (response.data.verification_skipped !== 1) {
            Vue.swal({
              title: this.$t('ui.errorOccured'),
              html: this.$t('customer.invalidTaxNumberLong'),
              type: 'warning',
              confirmButtonText: this.$t('ui.ok'),
              buttonsStyling: true
            });

            if (this.invoiceCountryPrefix === 'PL') {
              this.invoiceCity = '';
              this.invoiceName = '';
              this.invoicePostcode = '';
              this.invoiceStreet = '';
              this.invoiceBuilding = '';
              this.invoiceLocale = '';
            }

            this.taxNumberVerificationID = response.data.verification.id;
            this.lastCheckedPrefix = this.invoiceCountryPrefix;
            this.lastCheckedInvoiceTaxNumber = this.invoiceTaxNumber;
          }

          if (response.data.verification_skipped !== 1) {
            this.taxNumberVerifiedAt = response.data.verification.created_at;
            this.taxNumberVerifiedStatus = response.data.verification.status;
            this.taxNumberVerifiedIsActive = response.data.verification.is_active;
          }
        } else {
          Vue.swal({
            title: this.$t('ui.errorOccured'),
            html: this.$t('ui.tryAgain'),
            type: 'warning',
            confirmButtonText: this.$t('ui.ok'),
            buttonsStyling: true
          });
          this.taxNumberVerificationID = null;
          this.lastCheckedPrefix = null;
          this.lastCheckedInvoiceTaxNumber = null;
          this.taxNumberVerificationID = null;
        }
      }).catch(error => {
        console.log(error);
        Vue.swal({
          title: this.$t('ui.errorOccured'),
          html: this.$t('ui.tryAgain'),
          type: 'warning',
          confirmButtonText: this.$t('ui.ok'),
          buttonsStyling: true
        });
        this.checkingTaxNumber = false;
        this.taxNumberVerificationID = null;
      });
    },
    countryChange () {
      Vue.nextTick(() => {
        let countryData = this.countries.filter(country => country.id === this.countryID);

        if (countryData[0]) {
          let currencyID = countryData[0].default_currency_id;
          let languageID = countryData[0].default_language_id;

          if (currencyID) {
            Vue.set(this, 'currency_id', currencyID);
          } else {
            Vue.set(this, 'currency_id', null);
          }

          if (languageID) {
            Vue.set(this, 'language_id', languageID);
          } else {
            Vue.set(this, 'language_id', null);
          }
        }
      });
    },
    setInvoiceDataAsCorrespondenceData () {
      this.correspondenceCountryID = CommonGetters.getCountryIdByCode(this.invoiceCountryPrefix, this.countries);
      this.correspondenceCity = this.invoiceCity;
      this.correspondenceCompanyName = this.invoiceName;
      this.correspondencePostcode = this.invoicePostcode;
      this.correspondenceStreet = this.invoiceStreet;
      this.correspondenceBuilding = this.invoiceBuilding;
      this.correspondenceLocale = this.invoiceLocale;

      Vue.swal({
        title: this.$t('customer.correspondenceAddressSet'),
        html: '',
        type: 'success',
        timer: 2000,
        confirmButtonText: this.$t('ui.ok'),
        buttonsStyling: true
      });
    },
    setAgentID (agentData) {
      this.agentID = agentData.agentID;
    }
  },
  beforeDestroy () {
    this.$bus.$off('ui-select-agent-updated', this.setAgentID);
  }
};
</script>

<style lang="scss" scoped>
.customer-tags-list {
  background: #f8f8f8;
  border: 1px solid #eee;
  border-radius: 5px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  list-style-type: none;
  margin: 20px 0 0 0;
  padding: 20px 20px 10px 20px;

  li {
    font-size: 12px;
  }
}
</style>
